import { render } from "./ValidationResultFullscreenModal.vue?vue&type=template&id=652632d8"
import script from "./ValidationResultFullscreenModal.vue?vue&type=script&lang=js"
export * from "./ValidationResultFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__